import React, {useEffect, useState} from "react";
import I18n from 'i18n.js.erb'
import { parseBigInteger, parseExpansionNameAndEdition } from "../../utils/utils";

const SubBannerExpansionsCompact = ({parent_expansion, sub_expansions, game_name, handleNavigation,hasTranslations,handleHideSubExpansions}) => {


  return (
    <React.Fragment>
      <div className="col-12 pr-0 pl-8perc">

        <div className="pl-26px">

          <div className="collapse collapse-item d-block my-1">
            <div className="p-0">

              <div className="row w-100 m-0">

                {sub_expansions.map((sub_expansion, i) => {
                  return (
                    <React.Fragment key={sub_expansion.id + '_' + sub_expansion.language }>
                      <div className="col-12 p-0">
                        {
                          i === 0 &&
                          <i className="fas fa-angle-up ml-2 enable-filters-expansions-icon" style={{ cursor: "pointer" }}
                             onClick={(e) => handleHideSubExpansions(e, parent_expansion)}/>
                        }
                      </div>

                      <div id={"sub_expansion_" + sub_expansion.id + '_' + sub_expansion.language}
                           className="align-items-center d-flex text-center expansion-container-compact w-100 border-bottom-dark"
                           style={{cursor: "pointer"}}
                           onClick={(e) => handleNavigation(e, sub_expansion)}>

                        <div className="col-12">
                          {/*Name expansion*/}
                          <div className="col-12 p-0 pr-0 pl-0">
                            <div className="expansion__expansionName--size row text-night-blue text-align-left-imp
                              pl-0 pr-0 align-content-center minH-35px">

                              <div className={`${hasTranslations ? 'col-6' : 'col-3'} text-truncate`}>
                                {
                                  hasTranslations &&
                                    <img src={window.location.origin + `/images/flags/${sub_expansion.language}.png`}
                                         style={{ maxHeight: "20px", marginRight: "15px" }} alt=""/>
                                }
                                { parseExpansionNameAndEdition(sub_expansion.name, sub_expansion.edition, game_name) }
                              </div>
                              <div className={`${hasTranslations ? 'col-1' : 'col-4'} text-truncate`}>
                                {
                                  sub_expansion.en_name &&
                                  <p className="mb-0">{sub_expansion.en_name}</p>
                                }
                              </div>

                              <div className="col-2 pl-5">
                                {
                                  sub_expansion.icon_url &&
                                  <div key={sub_expansion.icon_url + "_" + i} className="col-xs-2 col-lg-1 mr-4">
                                    <img
                                      src={sub_expansion.icon_url}
                                      className="expansion__symbol--size img-size-logo-navbar"
                                    />
                                  </div>
                                }
                              </div>

                              {/*/!*counters*!/*/}
                              <div className="col-3 p-0 text-aiBlue">
                                <div className="row">
                                  <div className="col-6">
                                    <small>
                                      <span>
                                        {I18n.t('js.expansionsPage.aigCard')}:&nbsp;
                                        {parseBigInteger(sub_expansion.graded_cards_population)}
                                      </span>
                                    </small>
                                  </div>

                                  <div className="col-6">
                                    <small>
                                      <span>
                                        {I18n.t('js.expansionsPage.myCollection')}:&nbsp;
                                        {sub_expansion.blueprint_images_on_my_collection}/{sub_expansion.count_blueprint_images}
                                      </span>
                                    </small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  )
                })
                }
              </div>
            </div>

          </div>
        </div>


      </div>
    </React.Fragment>

  );
};

export default SubBannerExpansionsCompact;
